import {
	Button,
	ButtonGroup,
	Card,
	EmptyList,
	Grid,
	Lead,
	Search,
	Section,
} from '@tracsis/library/src';
import cx from 'classnames';
import React from 'react';

import { formatDate, getPostsInPageString } from '../../../../lib/helpers';
import { ArrowRight } from '../../../components/Icon';

const NewsList = ({
	posts,
	pageContext,
	hasSearch = false,
	hasFilters = false,
	showImages = false,
	showDates = false,
	hasSummary = true,
	defaultImage,
	defaultAlt,
	siteName = '',
	title,
	searchQuery,
	filterQuery,
	background = 'grey',
	className = '',
	snippet = false,
	snippetLink,
	cardTheme,
	cardBackground,
}: {
	posts: [];
	pageContext?: any;
	hasSearch?: boolean;
	hasFilters?: boolean;
	hasSummary?: boolean;
	showImages?: boolean;
	showDates?: boolean;
	siteName?: string;
	title?: string;
	searchQuery?: string | null;
	filterQuery?: string;
	background?:
	| 'white'
	| 'grey'
	| 'blue'
	| 'lightBlue'
	| 'darkerGrey'
	| 'darkGrey';
	className?: string;
	snippet?: boolean;
	snippetLink?: any;
	cardTheme?: 'classic' | 'plain' | undefined;
	cardBackground?: 'white' | 'grey' | 'lightBlue' | undefined;
	defaultImage?: string;
	defaultAlt?: string;
}) => {
	return (
		<>
			{hasSearch && (
				<Section background="darkerGrey" className={cx(className)}>
					<Search
						siteName={siteName}
						action="/news"
						label="news"
						searchQuery={searchQuery}
						hasFilter={hasFilters}
						filterQuery={filterQuery}
					/>

					{posts.length > 0 &&
						(searchQuery || filterQuery ? (
							<p>
								{posts.length} results found for '<strong>{searchQuery}</strong>
								'
							</p>
						) : (
							<p>
								Displaying{' '}
								{getPostsInPageString(
									pageContext.limit,
									pageContext.skip,
									pageContext.totalPosts
								)}{' '}
								results
							</p>
						))}
				</Section>
			)}

			<Section background={background}>
				{title && (
					<Lead align="left">
						<h2>{title}</h2>

						{snippet && (
							<ButtonGroup align="right" className="section-header-actions">
								<Button to={snippetLink} theme="inline">
									View all news
									<ArrowRight />
								</Button>
							</ButtonGroup>
						)}
					</Lead>
				)}

				{posts && posts.length > 0 ? (
					<Grid>
						{posts.map(({ node: post }, i) => {
							const story = JSON.parse(post.content);
							const { title, intro, image, date } = story;

							const optimisedImage = image?.id == null ?
								defaultImage ? defaultImage : null
								: `${image?.filename}/m/375x0`;

							const optimisedAlt = image?.alt == null ?
								defaultAlt ? defaultAlt : 'Tracsis'
								: image?.alt;

							return (
								<Card
									key={i}
									to={`/${post.full_slug}`}
									thumbnail={showImages ? optimisedImage : null}
									alt={showImages ? optimisedAlt : null}
									date={showDates ? formatDate(date) : ''}
									theme={cardTheme}
									background={cardBackground}
								>
									<div className="rhythm">
										<h3>{title}</h3>

										{hasSummary && intro && <p>{intro}</p>}
									</div>
								</Card>
							);
						})}
					</Grid>
				) : (
					<EmptyList>
						<p>There are no news posts found matching your search.</p>
					</EmptyList>
				)}
			</Section>

			{snippet && (
				<ButtonGroup align="center" className="section-footer-actions">
					<Button to={snippetLink} theme="inverted">
						View all news
						<ArrowRight />
					</Button>
				</ButtonGroup>
			)}
		</>
	);
};

export default NewsList;
